import React, { useMemo } from "react";
import { Doughnut, defaults } from "react-chartjs-2";

// HOOKS
import useColors from "../../hooks/useColors";

function ChartJobStatus({ countTimeRemain, title }) {
  const { interpolateColors } = useColors();

  const bg = [
    "rgb(239, 68, 68)", //red
    "rgb(255,140,0)",
    "rgb(240, 240, 0)",
    "rgb(230, 230, 230)",
  ]

  const bg_invert = [
    "rgb(230, 230, 230)",
    "rgb(240, 240, 0)",
    "rgb(255,140,0)",
    "rgb(239, 68, 68)", //red
  ]

  const styles = {
    backgroundColor: interpolateColors(),
  };

  const options = {
    title: {
      display: true,
      text: title,
      fontSize: 20,
    },
    legend: {
      display: true,
      position: "top",
    },
  };

  const data = useMemo(() => {
    const newData = Object.keys(countTimeRemain).map((key) => {
      return countTimeRemain[key];
    });

    return {
      labels: ["< 15 นาที", "< 30 นาที", "< 60 นาที", "> 60 นาที"],
      datasets: [
        {
          label: title,
          data: newData,
          backgroundColor: title =="Time Remain" ? bg:bg_invert,
          hoverOffset: 4,
        },
      ],
    };
  }, []);

  return (
    <div className="w-full lg:p-5 lg:mx-4">
      <Doughnut data={data} options={options} />
    </div>
  );
}

export default ChartJobStatus;
